import {
  monthlyValueCents,
  type ContactSubscription,
} from "utils/contacts/recurringBilling";

/** Stable identity, so the panel does not re-render on an empty array. */
const NO_SUBSCRIPTIONS: ContactSubscription[] = [];

/**
 * The seam. Signature-compatible with the real query: swap the body for a
 * `useQuery` on the contact id and no call site moves.
 */
export const useContactSubscriptions = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- the seam's
  // signature, which OUT-1408a fills with a useQuery on this id.
  contactId: string,
) => ({
  subscriptions: NO_SUBSCRIPTIONS,
  // Derived rather than stored, so the strip cannot disagree with the rows.
  monthlyValueCents: monthlyValueCents(NO_SUBSCRIPTIONS),
  loading: false,
  /** No backend yet, which the panel says rather than claiming zero plans. */
  connected: false,
});
